import { HttpAuthApi } from "./auth-api";
import { MockAuthApi } from "./mock-auth-api";
import { AuthService } from "./auth-service";
import { TelecomTokenService } from "./telecom-token-service";
import { createDefaultStorage } from "./storage";
import { TokenStore } from "./token-store";
import { TelecomTokenStore } from "./telecom-token-store";
import { isDevMode } from "../../shared/config/dev-mode";
import { STORAGE_KEYS } from "../../shared/config/storage-keys";

const storage = createDefaultStorage();
const tokenStore = new TokenStore(
  storage,
  STORAGE_KEYS.AUTH_ACCESS_TOKEN,
  STORAGE_KEYS.AUTH_REFRESH_TOKEN,
);
const telecomTokenStore = new TelecomTokenStore(
  storage,
  STORAGE_KEYS.TELECOM_TOKEN,
);

// Use mock API in dev mode, real API otherwise
const authApi = isDevMode() ? new MockAuthApi() : new HttpAuthApi();
const authService = new AuthService(authApi, tokenStore);
const telecomTokenService = new TelecomTokenService(telecomTokenStore);

export { authApi, authService, storage, tokenStore, telecomTokenStore, telecomTokenService };
export * from "./auth-service";
export * from "./token-store";
export * from "./telecom-token-store";
export * from "./telecom-token-service";
export * from "./telecom-token-by-phone-service";
export type { TelecomTokenService } from "./telecom-token-service";
export * from "./storage";
export * from "./auth-api";

